import { pxToRem } from '@fluentsms/agentnet-web-components';
import { Grid, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { formatDate } from 'utilities/dateFormatter';
import { OrderInsightsSummary } from './type';

interface ServiceOrderFormProps {
  index?: string;
  orderSummary?: OrderInsightsSummary[] | null;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    documentsTable: {
      width: '100%',
      padding: theme.spacing(0, 0, 3),
    },
    documentsTableHeader: {
      backgroundColor: '#F2F5F6',
      borderBottom: '1px solid #D9E0E5',
      fontWeight: 600,
      fontSize: pxToRem(14),
    },
    tableHeaderCell: {
      padding: pxToRem(12),
    },
    documentsTableList: {},
    tableRow: {
      borderBottom: `1px solid #E0E0E0`,
    },
    tableCell: {
      padding: pxToRem(13),
      display: 'flex',
      alignItems: 'center',
    },
    fileRow: {
      padding: 0,
      marginLeft: theme.spacing(1),
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    checkbox: {
      marginRight: theme.spacing(1),
    },
    incorporatedCell: {
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
    incorporatedCellDescription: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
    my1: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    mb1: {
      marginBottom: theme.spacing(1),
    },
    actions: {
      '& .MuiAgentNetButton': {
        marginRight: theme.spacing(2),
      },
    },
    fileCell: {
      justifyContent: 'space-between',
    },
    rowChecked: {
      backgroundColor: '#FDF8CF',
    },
  }),
);

const OrderInsightHistory = ({ index, orderSummary }: ServiceOrderFormProps) => {
  const classes = useStyles();

  const hasHistory = Array.isArray(orderSummary) && orderSummary.length > 0;

  // Sort by orderDate descending
  const sortedSummary = hasHistory
    ? [...orderSummary].sort((a, b) => new Date(b.orderedDate).getTime() - new Date(a.orderedDate).getTime())
    : [];

  return (
    <Grid item xs={12}>
      <Grid container className={classes.documentsTableHeader}>
        <Grid item sm={3} className={classes.tableHeaderCell}>
          Order Status
        </Grid>
        <Grid item sm={3} className={classes.tableHeaderCell}>
          Order Number
        </Grid>
        <Grid item sm={3} className={classes.tableHeaderCell}>
          Order Date
        </Grid>
        <Grid item sm={3} className={classes.tableHeaderCell}>
          Ordered By
        </Grid>
      </Grid>
      {hasHistory ? (
        sortedSummary.map((summary: OrderInsightsSummary, idx: number) => (
          <Grid container className={clsx(classes.tableRow)} key={idx}>
            <Grid item sm={3} className={clsx(classes.tableCell)}>
              <Typography variant="body2">{summary.orderStatus}</Typography>
            </Grid>
            <Grid item sm={3} className={clsx(classes.tableCell)}>
              <Typography variant="body2">{summary.orderNumber}</Typography>
            </Grid>
            <Grid item sm={3} className={clsx(classes.tableCell)}>
              <Typography variant="body2">{formatDate(summary.orderedDate as string, undefined, 'full')}</Typography>
            </Grid>
            <Grid item sm={3} className={clsx(classes.tableCell)}>
              <Typography variant="body2">{summary.orderedBy}</Typography>
            </Grid>
          </Grid>
        ))
      ) : (
        <Grid sm={12} container className={clsx(classes.tableRow)}>
          <Grid item sm={4} className={clsx(classes.tableCell)}>
            <Typography variant="body2">No history available.</Typography>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};
export default OrderInsightHistory;
